import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f1123c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inspectionCheck-container" }
const _hoisted_2 = { class: "first-tab" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫码巡检", -1))
const _hoisted_5 = { class: "second-tab" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_checkpoint = _resolveComponent("checkpoint")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_checkway = _resolveComponent("checkway")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.active) = $event)),
      animated: "",
      swipeable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "巡检点" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "addbtn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scan && _ctx.scan(...args)))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: require('@/assets/inspection/scan.png')
                  }, null, 8, _hoisted_3),
                  _hoisted_4
                ])
              ]),
              _createVNode(_component_checkpoint)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "巡检路线" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_checkway)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}